import { FormName, FormNames } from '@core/data-access/models/form/form.model';
import { Person, PersonType } from '@core/data-access/models/person.model';
import { includes, isNil } from 'lodash';

export const setSyncForms = (person: Person, syncForms: FormNames): FormNames => {
  const isSavedTicketHolder = !isNil(person.id);

  if (isSavedTicketHolder) {
    syncForms.push(FormName.SavedTicketHolders);
  }

  return syncForms;
};

export const setGoogleAutocompleteSyncForms = (person: Person | undefined, originForm: FormName) => {
  if (
    includes(
      [
        FormName.EditUserProfile,
        FormName.SavedTicketHolders,
        FormName.CreateTicketHolder,
        FormName.OrderEditTicketHolder,
        FormName.BuyerBillingAddress
      ],
      originForm
    )
  ) {
    return [originForm];
  }

  if (originForm === FormName.BuyerInformation) {
    return setSyncForms(person!, [FormName.BuyerInformation, FormName.TicketHolder]);
  }

  if (originForm === FormName.TicketHolder) {
    const syncForms: FormNames =
      person!.type === PersonType.BuyerIsHolder
        ? [FormName.BuyerInformation, FormName.TicketHolder]
        : [FormName.TicketHolder];

    return setSyncForms(person!, syncForms);
  }

  return [];
};
